import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';

const apiUrl = process.env.REACT_APP_API_URL || 'https://vakra.co.in/api';

function AdminLogin() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!formData.email.trim() || !formData.password) {
      setError('Email and password are required.');
      return;
    }

    try {
      setLoading(true);

      const payload = {
        email: formData.email.trim().toLowerCase(),
        password: formData.password,
      };

      const res = await axios.post(`${apiUrl}/admin/login`, payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      const token = res?.data?.token;
      const admin = res?.data?.admin;

      if (!token) {
        setError('Token not received from server.');
        return;
      }

      localStorage.setItem('adminToken', token);
      localStorage.setItem('adminUser', JSON.stringify(admin || {}));

      setMessage('Admin login successful.');

      setTimeout(() => {
        navigate('/admin/razorpay');
      }, 700);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          'Admin login failed.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>Admin Login</h2>
        <p style={styles.subtitle}>
          Approved admin credentials se login karein.
        </p>

        {message ? <div style={styles.success}>{message}</div> : null}
        {error ? <div style={styles.error}>{error}</div> : null}

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="email"
            name="email"
            placeholder="Admin Email"
            value={formData.email}
            onChange={handleChange}
            style={styles.input}
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            style={styles.input}
          />

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div style={styles.footerText}>
          No admin account? <Link to="/admin/signup">Signup here</Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f4f6f8',
    padding: '20px',
  },
  card: {
    width: '100%',
    maxWidth: '400px',
    background: '#fff',
    padding: '28px',
    borderRadius: '14px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
  },
  title: {
    margin: '0 0 8px 0',
    textAlign: 'center',
  },
  subtitle: {
    margin: '0 0 20px 0',
    textAlign: 'center',
    color: '#666',
    fontSize: '14px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  input: {
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    fontSize: '14px',
  },
  button: {
    padding: '12px',
    borderRadius: '8px',
    border: 'none',
    background: '#111827',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: '600',
  },
  success: {
    background: '#e7f8ec',
    color: '#166534',
    padding: '10px',
    borderRadius: '8px',
    marginBottom: '14px',
    fontSize: '14px',
  },
  error: {
    background: '#fde8e8',
    color: '#b91c1c',
    padding: '10px',
    borderRadius: '8px',
    marginBottom: '14px',
    fontSize: '14px',
  },
  footerText: {
    marginTop: '16px',
    textAlign: 'center',
    fontSize: '14px',
  },
};

export default AdminLogin;
